import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportManagerMainComponent } from './report-manager-main/report-manager-main.component';
import { MediaGalleryModule } from '../common/media-gallery/media-gallery.module';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';



@NgModule({
  declarations: [ReportManagerMainComponent],
  imports: [
    CommonModule,
    FormsModule,
    MediaGalleryModule,
    SharedModule
  ],
  exports:[ ReportManagerMainComponent ]
})
export class ReportmanagerModule { }

// translation loader moved to SharedModule
